import {UpdateBusinessProfileForm} from "../../../forms/update-business-profile-form";
import {useGetCurrentWorkspaceId} from "@tinct/core-workspace";
import {Alert, AlertDescription} from "@tinct/web-components";
import {Info} from "lucide-react";

export const EditBrandBusinessProfileTab = () => {

  const workspaceId = useGetCurrentWorkspaceId();

  return (
    <div className="flex flex-col gap-6">
      <Alert className="rounded-2xl p-4">
        <Info className="size-4" />
        <AlertDescription>
          The changes made will be used for future campaigns. If you want to apply them to campaigns that have already been generated, you will need to go back and regenerate the page variants.
        </AlertDescription>
      </Alert>
      <UpdateBusinessProfileForm organizationId={workspaceId} />
    </div>
  );
}
